var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLogin2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.19171 8.1H0C0.454004 3.5523 4.30942 0 8.99868 0C13.9936 0 18.0426 4.0293 18.0426 9C18.0426 13.9707 13.9936 18 8.99868 18C4.30942 18 0.454004 14.4477 0 9.9H7.1899V12.6L11.7119 9L7.1899 5.4V8.1H7.19171Z",
    fill: "#C6B382"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLogin2);
export default __webpack_public_path__ + "static/media/Icon_Login2.815954cfebf60ead92bf326636ffab6a.svg";
export { ForwardRef as ReactComponent };